import cloneDeep from 'lodash-es/cloneDeep';
export var EnumValueType;
(function (EnumValueType) {
    EnumValueType[EnumValueType["Key"] = 0] = "Key";
    EnumValueType[EnumValueType["Value"] = 1] = "Value";
})(EnumValueType || (EnumValueType = {}));
export var EnumSortDirection;
(function (EnumSortDirection) {
    EnumSortDirection[EnumSortDirection["descending"] = -1] = "descending";
    EnumSortDirection[EnumSortDirection["ascending"] = 1] = "ascending";
})(EnumSortDirection || (EnumSortDirection = {}));
export function enumMapper(enumDefinition, _a) {
    var _b = _a.filterValueMap, filterValueMap = _b === void 0 ? {} : _b, filter = _a.filter, sort = _a.sort, resourceKey = _a.resourceKey, type = _a.type;
    filter = filter || (function (key) { return isNaN(Number.parseInt(key, 10)); });
    var keys = Object.keys(enumDefinition).filter(filter);
    if (sort != null) {
        keys.sort(function (a, b) { return (a > b ? 1 : -1) * sort; });
    }
    return keys
        .map(function (keyStr) {
        var key = keyStr;
        var value = enumDefinition[key];
        if (type === EnumValueType.Key) {
            var mappedKey = value;
            value = enumDefinition[mappedKey];
        }
        var valueStr = "" + value;
        return {
            label: key.toString(),
            translationKey: resourceKey + "_" + key,
            value: filterValueMap[key] || valueStr,
        }; // FIXME: update the type of IDropdownOption.value
    });
}
export var globalStateFilter = function () { return cloneDeep([{
        value: true,
        label: 'Enabled',
        translationKey: 'GlobalFilter_Enabled',
    }, {
        value: false,
        label: 'Disabled',
        translationKey: 'GlobalFilter_Disabled',
    }]); };
export var globalStateFilterOnOff = function () { return cloneDeep([{
        value: true,
        label: 'Enabled',
        translationKey: 'GlobalFilter_On',
    }, {
        value: false,
        label: 'Disabled',
        translationKey: 'GlobalFilter_Off',
    }]); };
